import { Navigate } from "react-router-dom";
import { useLearningContext } from "../hooks/useLearningContext";
import { useErrorContext } from "../../global/hooks/useErrorContext";
import { Box, CircularProgress, Typography } from "@mui/material";
import { LearningList } from "./LearningList";

export const LearningLanding: React.FC = () => {
    const { learningList, isLoading } = useLearningContext();
    const { error } = useErrorContext();

    if (error) {
      return (
        <Navigate to="/error" />
      );
    }
    
    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 1, color:"primary.dark" }}>
              <CircularProgress disableShrink size={25} />
            </Box>
          );
    }

    if (!learningList?.List || learningList?.List.length === 0) {
        return (
          <Box padding={2}>
              <Typography variant="h6" color="secondary.dark" paragraph={true}>No learning websites to display.</Typography>
          </Box>
        );
    }

    return (
        <LearningList items={learningList?.List} />
    );
};